import { render, staticRenderFns } from "./BatchOpnameForm.vue?vue&type=template&id=4886d9f7&scoped=true"
import script from "./BatchOpnameForm.vue?vue&type=script&lang=js"
export * from "./BatchOpnameForm.vue?vue&type=script&lang=js"
import style0 from "./BatchOpnameForm.vue?vue&type=style&index=0&id=4886d9f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886d9f7",
  null
  
)

export default component.exports